<img src="assets/svg/{{ icon }}.svg" alt="" class="icon-sidebar" />
